export default __webpack_public_path__ + "static/Dont-Align-buttons-bottom-right-50edc11af0e93f464ef70396ecea18f20f19478621c82e643043fbd322462e1a.png";